/**
 * After logout, stay on the current screen when guests may see it.
 * Otherwise send the user home.
 */

let guestPageVisibility = null;

export function setGuestPageVisibility(pages) {
  const next = {};
  (pages || []).forEach((page) => {
    if (!page?.page_key) return;
    next[page.page_key] = !!(page.is_visible && page.is_visible_to_guests);
  });
  guestPageVisibility = next;
}

function pageKeyForPath(pathname) {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/') return 'home';
  if (path === '/shop' || path === '/products') return 'shop';
  if (path === '/about') return 'about';
  if (path === '/contact') return 'contact';
  if (path === '/developer') return 'developer';
  if (path === '/checkout' || path === '/checkout/success') return 'checkout';
  if (path === '/login') return 'login';
  if (path === '/register') return 'register';
  return null;
}

export function isGuestPublicPath(pathname = '/') {
  const path = String(pathname || '/').split('?')[0] || '/';

  if (
    path === '/admin'
    || path.startsWith('/admin/')
    || path === '/profile'
    || path.startsWith('/profile/')
    || path === '/newsletter'
  ) {
    return false;
  }

  const pageKey = pageKeyForPath(path);
  if (pageKey && guestPageVisibility && Object.prototype.hasOwnProperty.call(guestPageVisibility, pageKey)) {
    return guestPageVisibility[pageKey] !== false;
  }

  return true;
}

/** Path to open after logout, or null to stay on the current URL. */
export function getPostLogoutPath(pathname = typeof window !== 'undefined' ? window.location.pathname : '/') {
  const path = String(pathname || '/').split('?')[0] || '/';
  if (path === '/login' || path === '/register') return null;
  return isGuestPublicPath(path) ? null : '/';
}
